import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SaleItemInterface } from "../../../types/types";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../../store/slices/currentUserSlice";

export const useShare = (
  item?: Pick<SaleItemInterface, "id" | "name" | "description" | "files">,
  customUrl?: string,
  customText?: string,
) => {
  const [modalActive, setModalActive] = useState(false);
  const location = useLocation();
  const currentUser = useSelector(selectCurrentUser);

  const shareUrl = useMemo(() => {
    let url: string;

    if (customUrl) {
      url = customUrl;
    } else if (!item) {
      url = window.location.href;
    } else {
      const baseUrl = window.location.origin;
      const path = location.pathname;

      if (path.includes("/promo/")) {
        url = `${baseUrl}/promo/${item.id}`;
      } else if (path.includes("/item/")) {
        url = `${baseUrl}/item/${item.id}`;
      } else if (path.includes("/group/")) {
        url = `${baseUrl}/group/${item.id}`;
      } else if (path.includes("/contacts/")) {
        url = `${baseUrl}/contacts/${item.id}`;
      } else {
        url = window.location.href;
      }
    }

    if (currentUser?.uuid) {
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}ref=${currentUser.uuid}`;
    }

    return url;
  }, [customUrl, item, location.pathname, currentUser]);

  const shareText = useMemo(() => {
    if (customText) return customText;
    if (!item) return "";

    return item.description ? `${item.name}\n\n${item.description}` : item.name;
  }, [customText, item]);

  return {
    modalActive,
    setModalActive,
    shareUrl,
    shareText,
  };
};
